import React, { useState } from 'react';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

function Login({ isLoading, error, onSubmit, termsUrl, hasQuestionnaireId, recaptchaSiteKey }) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const validateEmail = (emailValue) => {
    if (!emailValue) {
      setEmailError('Email address is required.');
      return false;
    }
    const emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(emailValue)) {
      setEmailError('Please enter a valid email address format.');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    validateEmail(newEmail);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (validateEmail(email) && captchaToken) {
      onSubmit(email, captchaToken);
    }
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleCaptchaExpire = () => {
    setCaptchaToken(null);
  }

  return (
    <Card style={{ width: '40em' }} className="questionnaire-card p-4 shadow-sm">
      <Card.Body>
        <Card.Title className="questionnaire-card-title h3 mb-3">Access Questionnaire</Card.Title>

        <Form onSubmit={handleSubmit} noValidate>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className='card-form-title'>Email Address</Form.Label>
            <Card.Text className="text-muted mb-2">
              {hasQuestionnaireId ? 'Log into view questionnaire' : 'Please enter your email to receive an access code.'}
            </Card.Text>
            <Form.Control
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={handleEmailChange}
              required
              isInvalid={!!emailError}
            />

            {emailError && (
              <Form.Control.Feedback type="invalid">
                {emailError}
              </Form.Control.Feedback>
            )}
          </Form.Group>


          <Form.Group className="mb-3 d-flex">
            {recaptchaSiteKey && (
              <ReCAPTCHA
                sitekey={recaptchaSiteKey}
                onChange={handleCaptchaChange}
                onExpired={handleCaptchaExpire}
              />
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="terms-check"
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
              label={
                <>
                  I confirm that I have read and agree to the{' '}
                  <a href={termsUrl || '#'} target="_blank" rel="noopener noreferrer">
                    Terms and Conditions
                  </a>
                </>
              }
            />
          </Form.Group>

          {error && <Alert variant="danger">{error}</Alert>}

          <div className="d-grid">
            <Button variant="primary" type="submit" disabled={isLoading || !captchaToken || !!emailError || !agreedToTerms}>
              {isLoading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" />
                  <span className="ms-2">Sending...</span>
                </>
              ) : (
                'Send Code'
              )}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default Login;